export const MOBILE = "767px";
export const LAPTOP = "992px";
